import {useEffect,useState} from 'react';
import { useNavigate } from "react-router-dom";

import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
//import Box from '@mui/material/Box';

import TopPrivateNavigation from '../components/TopPrivateNavigation.jsx'
import Footer from '../components/Footer.jsx'
import AppLogout from '../components/AppLogout.jsx'

//services
import AuthService from '../service/auth'
import SettingsService from '../service/Settings'
import FoodFieldService from '../service/FoodField'
import FoodGroupService from '../service/FoodGroup'


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const formatJson=function(obj){
	return JSON.stringify(obj);
}

const defaultSettings1={'name':'Modules','type':'on_off',
	'settings':{
		'modules':{'name':'modules','type':'on_off',
			'options':['recipes','smart_portions','questionnaires']
		}
	}};
	
const defaultSettings={'id':'modules','name':'Modules','type':'on_off',
	'settings':{
			'recipes':{'name':'Recipes','on':false},
			'smart_portions':{'name':'Smart Portions','on':false},
			'questionnaires':{'name':'Questionnaires','on':false},
	}};

const Settings = () => {
	
	const navigate = useNavigate();
	//protected page check if logged in
	const [currentUser,setCurrentUser]=useState({});
	//global settings
	const [globalSettings,setGlobalSettings]=useState([]);
	
	const [value, setValue] = useState(0);
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
		
	useEffect(() => {
		if(!AuthService.isUserLoggedIn()){
			// not logged in navigate back to login
			navigate("/login");
		}else{
				setCurrentUser(AuthService.getCurrentUser());
				var account_type=AuthService.getCurrentUser().__t;
				console.log('account_type',account_type);
				
				console.log(AuthService.getCurrentUser());
				var currentUser=AuthService.getCurrentUser();
				//expired Account
				if(currentUser.expired){
					var string = "account_type="+AuthService.getCurrentUser().__t+"&type=expired";
					console.log('string',string);
					var encodedString = btoa(string); // Base64 encode the String
					console.log('encodedString',encodedString);
					navigate("/restricted/"+encodedString);
					
				}else{//unverified account
					if(!currentUser.email_verified){
						var string = "account_type="+AuthService.getCurrentUser().__t+"&type=emaiverification";
						console.log('string',string);
						var encodedString = btoa(string); // Base64 encode the String
						console.log('encodedString',encodedString);
						navigate("/restricted/"+encodedString);
						
					}else{////force change Password
						if(currentUser.force_password_change){
							//not implemented	
						
						}else{
							//load
							if(account_type=='Admin'){//Admin
								//createTestGlobalSettings();
								loadGlobalSettings();
								loadFoodFields();
								loadFoodGroups();
								//deleteAll();
							}else if(account_type=='Master'){//Master
								loadGlobalSettings();
									loadFoodFields();
									loadFoodGroups();
							}else if(account_type=='Researcher'){//Researcher
								
							}
						}
					}
				}	
		}
	}, []);
	
	function createTestGlobalSettings(){
		
		SettingsService.create(defaultSettings).then(function(res){
			//setGlobalSettings(res.data);
			console.log(res.data);
			//setProjectFound(true);
		}).catch(function(error){
			console.log(error);
			//setProjectFound(false);
		});
	}
	
	function deleteAll(){
		SettingsService.deleteAll().then(function(res){
			//setGlobalSettings(res.data);
			console.log(res.data);
			//setProjectFound(true);
		}).catch(function(error){
			console.log(error);
			//setProjectFound(false);
		});
	}
	
	
	function loadGlobalSettings(){
		SettingsService.getAll().then(function(res){
			setGlobalSettings(res.data);
			console.log(res.data);
			//setProjectFound(true);
		}).catch(function(error){
			console.log(error);
			//setProjectFound(false);
		});
	}
	
	const handleResetConfig=(e) => {
		SettingsService.deleteAll().then(function(res){
			//setGlobalSettings(res.data);
			console.log(res.data);
			
				SettingsService.create(defaultSettings).then(function(res1){
					//setGlobalSettings(res1.data);
					console.log(res1.data);
					loadGlobalSettings();
					//setProjectFound(true);
				}).catch(function(error){
					console.log(error);
					//setProjectFound(false);
				});
			//setProjectFound(true);
		}).catch(function(error){
			console.log(error);
			//setProjectFound(false);
		});
		
	
	};
	
	//
	const handleSwitch=(e,setting,key,object,on_off) => {
		console.log('setting',setting);
		console.log('key',key);
		console.log('object',object);
		console.log('on_off',on_off);
		let _settings=setting;
		_settings['settings'][key]['on']=on_off;
		SettingsService.update(_settings).then(function(res1){
			console.log(res1.data);
			loadGlobalSettings();
		}).catch(function(error){
			console.log(error);
		});
	};
	
	/*Food Field*/
	const [foodFieldData,setFoodFieldData]=useState([]);
	const [tempFoodField,setTempFoodField]=useState({'field':'','name':'','type':'','unit':''});
	function loadFoodFields(){
		FoodFieldService.getAll().then(function(res){
			setFoodFieldData(res.data);
			console.log(res.data);
		}).catch(function(error){
			console.log(error);
		});
	}
	//
	const handleEditFoodFieldModal=(e,ff) => {
		console.log('ff',ff);
		setTempFoodField(ff);
		setOpenFoodFieldEditModal(true);
	}
	
	const [openFoodFieldEditModal, setOpenFoodFieldEditModal] = useState(false);

	const handleFoodFieldEditModalClose = () => {
		setOpenFoodFieldEditModal(false);
	};
	
	const handleFoodFieldEdit = () => {
		FoodFieldService.update(tempFoodField).then(function(res){
			console.log(res.data);
			setOpenFoodFieldEditModal(false);
			loadFoodFields();
		}).catch(function(error){
			console.log(error);
		});
	};
	
	const handleOnChangeFoodFieldEditValue = (e,key) => {
		console.log(e.target.value,key);
		setTempFoodField({...tempFoodField,
			[key]: e.target.value,
		})
	};
	
	/*Food Group*/
	const [foodGroupData,setFoodGroupData]=useState([]);
	const [tempFoodGroup,setTempFoodGroup]=useState({'name':''});
	const [openFoodGroupEditModal, setOpenFoodGroupEditModal] = useState(false);
	
	function loadFoodGroups(){
		FoodGroupService.getAll().then(function(res){
			setFoodGroupData(res.data);
			console.log(res.data);
		}).catch(function(error){
			console.log(error);
		});
	}
	//
	const handleEditFoodGroupModal=(e,fg) => {
		console.log('fg',fg);
		setTempFoodGroup(fg);
		setOpenFoodGroupEditModal(true);
	}

	const handleFoodGroupEditModalClose = () => {
		setOpenFoodGroupEditModal(false);
	};
	
	const handleFoodGroupEdit = () => {
		FoodGroupService.update(tempFoodGroup).then(function(res){
			console.log(res.data);
			setOpenFoodGroupEditModal(false);
			loadFoodGroups();
		}).catch(function(error){
			console.log(error);
		});
	};
	
	const handleOnChangeFoodGroupEditValue = (e,key) => {
		console.log(e.target.value,key);
		setTempFoodGroup({...tempFoodGroup,
			[key]: e.target.value,
		})
	};
	
  return(
  <>
	<TopPrivateNavigation/>
	<AppLogout>
		
		<br/>
		<Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/">
          Home
        </Link>
		 <Typography color="text.primary">Settings</Typography>
      </Breadcrumbs>
	  
	  <br/>
	  <Divider />
		<br/>
		

	
	{/* Admin */}
	{(currentUser.__t=='Admin') ?
	<>
	<br/>
	
		<Button  onClick={(e) => handleResetConfig(e)} variant="contained" color="error">
			Reset
		</Button><br/>
	<br/>
	
	{globalSettings.map((setting,index) => (

		<>
		
		<Box key={index} sx={{ width: '100%' }}>
			  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
				<h3>{setting.name}</h3>
					{(setting.type=='on_off') ?
					<>
					
						<Table sx={{  }} aria-label="simple table">
						<TableBody>
						  {Object.entries(setting.settings).map(([key, object]) => (
							<TableRow
							  key={object.id}
							  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
							>
							  <TableCell align="left">{object.name}</TableCell>
							  <TableCell align="center">
								{object.on ?
								<>
									<Button  onClick={(e) => handleSwitch(e,setting,key,object,false)} variant="contained" color="success">
										Turn Off
									</Button>
								</>
								:<>
								<Button  onClick={(e) => handleSwitch(e,setting,key,object,true)} variant="contained" color="primary">
									Turn On
								</Button>
								
								</>}
							  
							  
							  </TableCell>
							  <TableCell align="right"></TableCell>
							</TableRow>
						  ))}
						</TableBody>
						</Table>
					</>
					:<></>}
				 
					<br/>
					<br/>
			  </Box>
		</Box>
			  
		
	
		</>
	))}
	
	</>
	:<></>}
	{/*food field dialog*/}
	    <Dialog
			open={openFoodFieldEditModal}
			onClose={handleFoodFieldEditModalClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		  >
			<DialogTitle id="alert-dialog-title">
			  {"Edit Food Field"}
			</DialogTitle>
			<DialogContent>
			  <DialogContentText id="alert-dialog-description">
			
			  </DialogContentText>
			  
			      <Box
					noValidate
					component="form"
					sx={{
					  display: 'flex',
					  flexDirection: 'column',
					  m: 'auto',
					  width: 'fit-content',
					}}
				  >

				 <FormControl  sx={{ m: 1, width: 250 }}>
					<TextField disabled onChange={(e) => {handleOnChangeFoodFieldEditValue(e,'field')}} value={tempFoodField['field']} id="standard-basic" label="Field" variant="standard" />
				</FormControl>
				
				 <FormControl  sx={{ m: 1, width: 250 }}>
					<TextField onChange={(e) => {handleOnChangeFoodFieldEditValue(e,'name')}} value={tempFoodField['name']} id="standard-basic" label="Name" variant="standard" />
				</FormControl>
			
				 <FormControl  sx={{ m: 1, width: 250 }}>
					<TextField onChange={(e) => {handleOnChangeFoodFieldEditValue(e,'type')}} value={tempFoodField['type']} id="standard-basic" label="Type" variant="standard" />
				</FormControl>
				
				 <FormControl  sx={{ m: 1, width: 250 }}>
					<TextField onChange={(e) => {handleOnChangeFoodFieldEditValue(e,'unit')}} value={tempFoodField['unit']} id="standard-basic" label="Unit" variant="standard" />
				</FormControl>
				   
				  </Box>
			</DialogContent>
			<DialogActions> 
				
				<Button  variant="outlined" onClick={handleFoodFieldEditModalClose}  > Cancel</Button>
				<Button color="primary"  onClick={handleFoodFieldEdit} autoFocus >Save</Button>
			
			</DialogActions>
		  </Dialog>
		  
		  {/*food group dialog*/}
		      <Dialog
			open={openFoodGroupEditModal}
			onClose={handleFoodGroupEditModalClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		  >
			<DialogTitle id="alert-dialog-title">
			  {"Edit Food Group"}
			</DialogTitle>
			<DialogContent>
			  <DialogContentText id="alert-dialog-description">
			
			  </DialogContentText>
			  
			      <Box
					noValidate
					component="form"
					sx={{
					  display: 'flex',
					  flexDirection: 'column',
					  m: 'auto',
					  width: 'fit-content',
					}}
				  >
				
				 <FormControl  sx={{ m: 1, width: 250 }}>
					<TextField onChange={(e) => {handleOnChangeFoodGroupEditValue(e,'name')}} value={tempFoodGroup['name']} id="standard-basic" label="Name" variant="standard" />
				</FormControl>
				 <FormControl  sx={{ m: 1, width: 250 }}>
					<TextField onChange={(e) => {handleOnChangeFoodGroupEditValue(e,'title')}} value={tempFoodGroup['title']} id="standard-basic" label="Title" variant="standard" />
				</FormControl>
				

				   
				  </Box>
			</DialogContent>
			<DialogActions> 
				
				<Button  variant="outlined" onClick={handleFoodGroupEditModalClose}  > Cancel</Button>
				<Button color="primary"  onClick={handleFoodGroupEdit} autoFocus >Save</Button>
			
			</DialogActions>
		  </Dialog>
	
	{/* Master */}
	{(currentUser.__t=='Master') ?
	<>
		    <Box sx={{ width: '100%' }}>
			  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
				<Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
				  <Tab label="Modules" {...a11yProps(0)} />
				  <Tab label="Food Fields" {...a11yProps(1)} />
				  <Tab label="Food Groups" {...a11yProps(2)} />
	
				</Tabs>
			  </Box>
			  <CustomTabPanel value={value} index={0}>
			
				<br/>
		
		<Button  onClick={(e) => handleResetConfig(e)} variant="contained" color="error">
			Reset
		</Button><br/>
	<br/>
	
	{globalSettings.map((setting,index) => (

		<>
		
		<Box key={index} sx={{ width: '100%' }}>
			  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
				<h3>{setting.name}</h3>
					{(setting.type=='on_off') ?
					<>
					
						<Table sx={{  }} aria-label="simple table">
						<TableBody>
						  {Object.entries(setting.settings).map(([key, object]) => (
							<TableRow
							  key={object.id}
							  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
							>
							  <TableCell align="left">{object.name}</TableCell>
							  <TableCell align="center">
								{object.on ?
								<>
									<Button  onClick={(e) => handleSwitch(e,setting,key,object,false)} variant="contained" color="success">
										Turn Off
									</Button>
								</>
								:<>
									<Button  onClick={(e) => handleSwitch(e,setting,key,object,true)} variant="contained" color="primary">
										Turn On
									</Button>
								</>}
								
							  </TableCell>
							  <TableCell align="right"></TableCell>
							</TableRow>
						  ))}
						</TableBody>
						</Table>
					</>
					:<></>}
				 
					<br/>
					<br/>
			  </Box>
		</Box>
	
		
	
		</>
	))}
						
			
			
			  </CustomTabPanel>
			   <CustomTabPanel value={value} index={1}>
			
				<Box  sx={{ width: '100%' }}>
								<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
								<Table sx={{  }} aria-label="simple table">
								<TableHead>
								  <TableRow>
									<TableCell align="left">#</TableCell>
									<TableCell align="left">Field</TableCell>
									<TableCell align="left">Name</TableCell>
									<TableCell align="left">Type</TableCell>
									<TableCell align="left">Unit</TableCell>
									<TableCell align="left"></TableCell>
								  </TableRow>
								</TableHead>
								<TableBody>
								  {foodFieldData.map((ff,index) => (
									<TableRow  key={index}  sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
									  <TableCell align="left">{index+1}</TableCell>
									  <TableCell align="left">{ff.field}</TableCell>
									  <TableCell align="left">{ff.name}</TableCell>
									  <TableCell align="left">{ff.type}</TableCell>
									  <TableCell align="left">{ff.unit}</TableCell>
									  <TableCell align="left">
										<IconButton onClick={(e) => handleEditFoodFieldModal(e,ff)} color="primary" aria-label="">
										  <EditIcon />
										</IconButton>
																			  
									  </TableCell>
									</TableRow>
								  ))}
								</TableBody>
								</Table>
							
							
						 
							<br/>
							<br/>
					  </Box>
				</Box>
			
			
			  </CustomTabPanel>
			  <CustomTabPanel value={value} index={2}>
			
			
							<Box  sx={{ width: '100%' }}>
								<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
								<Table sx={{  }} aria-label="simple table">
								<TableHead>
								  <TableRow>
									<TableCell align="left">#</TableCell>
									<TableCell align="left">Code</TableCell>
									<TableCell align="left">Name</TableCell>
									<TableCell align="left"></TableCell>
								  </TableRow>
								</TableHead>
								<TableBody>
								  {foodGroupData.map((fg,index) => (
									<TableRow  key={index}  sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
									  <TableCell align="left">{index+1}</TableCell>
									  <TableCell align="left">{fg.code}</TableCell>
										<TableCell align="left">{fg.name}</TableCell>
									  <TableCell align="left">
										<IconButton onClick={(e) => handleEditFoodGroupModal(e,fg)} color="primary" aria-label="">
										  <EditIcon />
										</IconButton>
																			  
									  </TableCell>
									</TableRow>
								  ))}
								</TableBody>
								</Table>
							
							
						 
							<br/>
							<br/>
					  </Box>
				</Box>
			
			
			  </CustomTabPanel>

			</Box>
	
	
	</>
	:<></>}
	
	{/* Researcher */}
	{(currentUser.__t=='Researcher') ?
	<>
	
	</>
	:<></>}
	<Footer />
	</AppLogout>
	</>
  ) 
  ;
};

export default Settings;